module.exports = __webpack_public_path__ + "img/point-agile-2.4582b77d.png";